import React, { useEffect, useState } from "react";
import { IPetsDashboardResponseModel } from "../../../../typings/models/PetsDashboardResponseModel";
import { useNavigate, Link } from "react-router-dom";
import { IOwnerStatus } from "../../../../typings/models/OwnerStatus";
import { ownerChangeToNewOwner } from "../../../../api/apimethods";
import PetsDashboard from "./PetsDashboard";
import moment from "moment";

interface RegOwnerTransferGridRowProps {
  data: any;
  onRemoveItem: (item: any) => void;
  onUpdateItem: (item: any, status: string) => void;
}

const PetsRegOwnerTransferGridRow: React.FC<
  RegOwnerTransferGridRowProps & { activeButton: string }
> = ({ data, onRemoveItem, onUpdateItem, activeButton }) => {
  let navigate = useNavigate();
  // const [prevData, setPrevData] = useState<any[]>([]);
  const transferType = "PetsPendingRegistration";
  let microchipNo = "";

  async function handleOwnerChangeToNewOwner(OwnerTransferInfo: any) {
    var response = null;
    try {
      response = await ownerChangeToNewOwner(OwnerTransferInfo);
      if (response.data) {
        var status = "";
        let msg = "Your request for transfer application has been ";
        if (OwnerTransferInfo.Status === "Accept") {
          msg += "accepted.";
          status = "4";
        } else if (OwnerTransferInfo.Status === "Decline") {
          msg += "declined.";
          status = "5";
        } else if (OwnerTransferInfo.Status === "Cancel") {
          msg += "cancelled.";
          status = "6";
        }
        alert(msg);
        onUpdateItem(data, status);
      } else {
        // API call failed
        const errorMessage = "An error occurred. Please try again.";
        alert(errorMessage);
      }
    } catch (error) {}
  }

  const handleButtonClick = () => {
    // do not change the owner details

    const buttonId = "v-pills-homeT-tab";
    const tabId = "v-pills-homeT";
    const bannerId = 4;
    let petsRegistrationId = data.petsRegistrationId;

    let path = `/application-for-pets`;
    navigate(path, {
      state: { petsRegistrationId, buttonId, tabId, bannerId },
    });
  };

  const handlePetsTransferEditClick = () => {
    navigate("/application-for-pets", {
      state: {
        petsRegistrationId: data.petsRegistrationId,
        petsTransferApplicationId: data.petsTransferApplicationId,
        buttonId: "v-pills-petstransferedit-tab",
        tabId: "v-pills-petstransferedit",
        bannerId: 8,
      },
    });
  };

  return (
    <tr>
      <td>
        <a
          href="#"
          onClick={handlePetsTransferEditClick}
          className="link-style"
        >
          {data.referenceNo}
        </a>
      </td>
      <td>{data.applicationType}</td>
      {data.applicationType === "Owner Transfer" && (
        <td>{data.newOwnerName}</td>
      )}
      {data.applicationType === "Owner Transfer" && (
        <td>{data.petsMicrochipNo}</td>
      )}
      {/* {data.applicationType === "Owner Transfer" && (
        <td className="center-content">{data.transferNo}</td>
      )} */}
      {data.applicationType === "Owner Transfer" && <td>{data.ownerName}</td>}
      {data.applicationType === "Owner Transfer" && (
        <td>
          {data.status === "1" && "Draft"}
          {data.status === "2" && "Pending Acceptance"}
          {data.status === "3" && "Pending Acceptance"}
          {data.status === "4" && "Accepted"}
          {data.status === "5" && "Declined"}
          {data.status === "6" && "Cancelled"}
        </td>
      )}
      {data.applicationType === "Owner Transfer" && (
        <td>{moment(data.submittedDate).format("DD/MM/yyyy, hh:mm a")}</td>
      )}
      {/* <td>
        {data.applicationType === "Owner Transfer" && data.status === "1" && (
          <a href="#" className="link" onClick={handlePetsTransferEditClick}>
            Accept/Decline
          </a>
        )}
      </td> */}
    </tr>
  );
};

export default PetsRegOwnerTransferGridRow;
